import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getLoginUser, changeOrgRole, getOrgRoleList as _getOrgRoleList } from '@data/login';
export default {
  name: 'company',
  data: function data() {
    return {
      isClick: false,
      options: [],
      value: ''
    };
  },
  mounted: function mounted() {
    if (this.getQueryString('appid') != null && this.getQueryString('code') != null) {
      this.isClick = true;
    } //   let changeOrgCode = JSON.parse(window.localStorage.getItem("userInfo")).appList.filter(ele => ele.appCode == 'bms')[0].orgList.filter(ele => ele.flag)[0].orgCode
    //   this.companyFn(changeOrgCode)


    this.companyList();
  },
  methods: {
    // 获取url参数
    getQueryString: function getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    setUserRole: function setUserRole(data) {
      this.tools.removeLocalStorage('userRole');
      var orgList = data.appList.filter(function (el) {
        return el.appCode == 'bms';
      })[0].orgList.filter(function (ele) {
        return ele.flag;
      })[0];
      var roleVo = orgList.list.filter(function (ele) {
        return ele.roleType == data.type;
      })[0];
      roleVo.orgCode = orgList.orgCode;
      roleVo.orgName = orgList.orgName;
      roleVo.orgType = orgList.orgType;
      this.tools.setLocalStorage('userRole', roleVo);
    },
    companyList: function companyList() {
      var _this = this;

      var _that = this;

      getLoginUser().then(function (resp) {
        _this.getOrgRoleList(resp);

        _that.tools.removeLocalStorage('userInfo');

        _that.tools.setLocalStorage('userInfo', resp);

        _this.setUserRole(resp);

        if (_this.tools.getLocalStorage('userInfo') != '' && _this.tools.getLocalStorage('userInfo') != null && _this.tools.getLocalStorage('userInfo') != undefined) {
          _this.userInfo = _this.tools.getLocalStorage('userInfo');
        }
      }).catch(function () {});
    },
    // 获取机构集合
    getOrgRoleList: function getOrgRoleList(resp) {
      var _this2 = this;

      _getOrgRoleList({
        appCode: 'bms'
      }).then(function (res) {
        res.map(function (ele) {
          _this2.options.push(Object.assign(ele, {
            code: "".concat(ele.orgCode, "_").concat(ele.type),
            name: "".concat(ele.orgName, "_").concat(ele.typeName)
          }));
        });
        _this2.value = resp.loginOrgCode + '_' + resp.type;
      });
    },
    // 切换单位
    companyFn: function companyFn(item) {
      var _this3 = this;

      var params = {
        orgCode: item.split('_')[0],
        roleType: item.split('_')[1],
        busId: this.options.filter(function (ele) {
          return ele.code == item;
        })[0].busId
      };
      changeOrgRole(params).then(function (res) {
        _this3.tools.removeLocalStorage('userInfo');

        _this3.tools.setLocalStorage('userInfo', res);

        window.location.reload();
      }).catch(function () {});
    }
  }
};